<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Users
        <small>List of users</small>
      </h1>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-sm-6">
          <select v-model="fb_selected">
            <option v-for="(fb, index) in fb_users" v-if="fb.id" :value="index">{{fb.firstname}} {{fb.lastname}} | id: {{fb.id}}</option>
          </select>
          <div v-if="fb_selected >= 0">
            <h3>Ovaj korisnik se gasi i menja se sa korisnikom desno:</h3>
            <p>Odabran korisnik: <a :href="'https://facebook.com/' +  fb_users[fb_selected].facebook_id">{{ fb_users[fb_selected].firstname }} {{ fb_users[fb_selected].lastname }}</a></p>
            <p>Godine: {{fb_users[fb_selected].age_range}}</p>
            <p>Nick: {{testUri(fb_users[fb_selected].nickname)}}</p>
            <p>ID: {{fb_users[fb_selected].id}}</p>
          </div>
        </div>
        <div class="col-sm-6">
          <select v-model="fb_selected_2">
            <option v-for="(fb, index) in fb_users" v-if="fb.id" :value="index">{{fb.firstname}} {{fb.lastname}} | id: {{fb.id}}</option>
          </select>
          <div v-if="fb_selected_2 > 0">
            <h3>Ovaj nalog ostaje:</h3>
            <p>Odabran korisnik: <a :href="'https://facebook.com/' +  fb_users[fb_selected_2].facebook_id">{{ fb_users[fb_selected_2].firstname }} {{ fb_users[fb_selected_2].lastname }}</a></p>
            <p>Godine: {{fb_users[fb_selected_2].age_range}}</p>
            <p>Nick: {{testUri(fb_users[fb_selected_2].nickname)}}</p>
            <p>ID: {{fb_users[fb_selected_2].id}}</p>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-sm-4 col-sm-offset-4">
          <button v-if="fb_selected >= 0 && fb_selected_2 >= 0" @click="mergeAccounts()" class="btn btn-primary">Izvrsi zamenu naloga</button>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
  export default {
    name: 'FBUsers',

    data: function () {
      return {
        form: new Form({}),
        fb_users: [],
        fb_selected: -1,
        fb_selected_2: -1,
        first_selected: {},
        second_selected: {},
        role: 0
      }
    },
    methods: {
      fetchFBUsers: function () {
        var self = this
        this.form.post(baseUrl + 'Admin/getAllFBUsers').then(function (result) {
          if (result.status === 1) {
            self.fb_users = result.list
          }
        }, function (reason) {
        })
      },
      testUri: function (arg) {
        var valu = ''
        try {
          valu = decodeURI(arg)
        } catch (err) {
          valu = arg
          console.log('greska')
        }
        return valu
      },
      mergeAccounts: function () {
        var first = this.fb_users[this.fb_selected]
        var second = this.fb_users[this.fb_selected_2]
        var data = {
          'facebook_id_first': first.facebook_id,
          'facebook_id_second': second.facebook_id,
          'id_one': first.id,
          'id_two': second.id
        }
        this.form.post(baseUrl + 'Admin/facebookMerge', data).then(function (result) {
          if (result.status === 1) {
            window.location.reload()
          }
        }, function (reason) {
            // rejection
        })
      }
    },
    mounted: function () {
      this.role = Number(this.$store.state.role)
      if (Number(this.$store.state.role) < 33) {
        this.$router.push('/dashboard')
      }
      this.fetchFBUsers()
    }
  }
</script>



// WEBPACK FOOTER //
// facebook.vue?09f6de0e